"use client";

import * as React from "react";
import { CentralizedDrawer } from "../global-drawer-stack";
import { useGlobalModalStack } from "../global-modal-stack";

interface ResponsiveModalDrawerProps {
  drawerId: string;
  side: "top" | "bottom" | "left" | "right";
  className?: string;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  showCloseButton?: boolean;
  children: React.ReactNode;
  stickySubmit?: React.ReactNode;
}

/**
 * Mobile drawer variant of ResponsiveModal
 * Renders content in a drawer for mobile devices
 * Syncs drawer close events back to the modal stack for URL synchronization
 */
export const ResponsiveModalDrawer: React.FC<ResponsiveModalDrawerProps> = ({
  drawerId,
  side,
  className = "",
  title,
  description,
  showCloseButton = true,
  children,
  stickySubmit,
}) => {
  // Get modal stack to sync drawer close events
  let modalStack: any = null;
  try {
    modalStack = useGlobalModalStack();
  } catch (e) {
    // Modal stack not available
  }

  const handleDrawerClose = React.useCallback(() => {
    // Sync drawer close to modal stack (which will update URL)
    if (modalStack) {
      modalStack.closeModal(drawerId);
    }
  }, [modalStack, drawerId]);

  return (
    <CentralizedDrawer
      drawerId={drawerId}
      side={side}
      className={className}
      title={title}
      description={description}
      showCloseButton={showCloseButton}
      enableSwipeGesture={true}
      onClose={handleDrawerClose}
    >
      <div className="flex-1 min-h-0 overflow-y-auto p-4">
        {children}
      </div>

      {stickySubmit && (
        <div className="border-t p-4">
          {stickySubmit}
        </div>
      )}
    </CentralizedDrawer>
  );
};
